module.exports = __webpack_public_path__ + "img/University-of-Brighton-Abroad.4924c49a.jpg";